import { render } from "./EditTextModal.vue?vue&type=template&id=218a1384"
import script from "./EditTextModal.vue?vue&type=script&lang=js"
export * from "./EditTextModal.vue?vue&type=script&lang=js"

import "./EditTextModal.vue?vue&type=style&index=0&id=218a1384&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__